// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EditUser_iconClass__AkhTR {\n  font-size: 18 !important;\n}\n\nspan:has(.EditUser_iconClass__AkhTR) + span {\n  font-size: 14px !important;\n}\n", "",{"version":3,"sources":["webpack://./src/components/AdminPanel/EditUser.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".iconClass {\n  font-size: 18 !important;\n}\n\nspan:has(.iconClass) + span {\n  font-size: 14px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconClass": "EditUser_iconClass__AkhTR"
};
export default ___CSS_LOADER_EXPORT___;
